import { getAction } from "@/api/manage";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
export default {
  components: {
    JDictSelectTag: JDictSelectTag
  },
  data: function data() {
    return {
      info: {},
      cmsDataSource: [],
      pagination: {
        onChange: function onChange(page) {
          console.log(page);
        },
        pageSize: 10
      },
      queryParam: {
        cmsType: ""
      }
    };
  },
  created: function created() {
    this.getCmsList(this.$route.query.type, this.$route.query.kw);
  },
  watch: {
    $route: function $route(v) {
      this.getCmsList(this.$route.query.type, this.$route.query.kw);
    }
  },
  methods: {
    getCmsList: function getCmsList(type, kw) {
      var _this = this;
      this.cmsDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        keyword: kw,
        cmsType: type,
        pageSize: 999
      }).then(function (res) {
        if (res.success) {
          _this.info = res.result;
          _this.cmsDataSource = res.result.records;
        }
      });
    },
    toDetail: function toDetail(item) {
      var route = this.$router.resolve({
        path: "/cms/detail",
        query: {
          id: item.id
        }
      });
      window.open(route.href, '_blank');
    },
    handleChangeType: function handleChangeType(v) {}
  }
};